var UserResource = function() {
  var self = this;

  self.get = function(options) {
    request.get($.extend(true, {
      url: '/api/user/current'
    }, options));
  };

  self.add = function(data, options) {
    request.post($.extend(true, {
      url: '/api/users',
      data: data
    }, options));
  };

  self.newCreditPayment = function(data, options) {
    request.post($.extend(true, {
      url: '/api/user/current/credits',
      data: data
    }, options));
  };

  self.executeCreditPayment = function(data, options) {
    request.post($.extend(true, {
      url: '/api/user/current/credits/execute',
      data: data
    }, options));
  };

  self.validateDiscount = function(code, options) {
    request.post($.extend(true, {
      url: '/api/user/current/discount',
      data: {
        code: code.toUpperCase()
      }
    }, options))
  }

  self.clearDiscount = function(options) {
    request.delete($.extend(true, {
      url: '/api/user/current/discount'
    }, options));
  }

  self.dismissMessage = function(title, options) {
    request.delete($.extend(true, {
      url: '/api/user/current/message/' + title
    }, options));
  }
};

window.userResource = new UserResource();